<template>
  <div class="content bg8">
    <div class="middled">

      <div class="basehero" style="text-align: center;">
        <h1>
          Choose a Package
        </h1>
        <p>
          Get Focus & Clarity with our all-in-one Adaptive Intelligence Platform.
        </p>
      </div>


<!-- SaaS (Platform) Pricing -->
<div class="basehero" style="">
  <div class="row">

    <!-- Starter / Small Team -->
    <div class="column">
      <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;border-radius: 20px;">
        <h2 style="text-align:center" title="Startup Launch">Launch</h2>
        <ul class="pricing-list">
          <li>Adaptive Intelligence AI</li>
          <li>Startup Frameworks</li>
          <li>AI-enhanced Workspaces</li>
          <li>AI-enhanced Tasks</li>
          <li>Progress Tracking</li>
          <li>Visual Reporting</li>
          <li>One User</li>
        </ul>
        <p style="font-size:2rem;text-align:center">
          $75<br>
          <span style="font-size:.8rem;">per month</span>
        </p>
        <p style="text-align:center">
          <a href="https://buy.stripe.com/eVq3cubvm4YFaUe9cK14403" target="_blank" rel="nofollow">
            <button style="padding:10px 20px;"> Subscribe </button>
          </a>
        </p>
      </div>
    </div>

    <!-- Growing Team -->
    <div class="column">
      <div style="padding:0 10px;background:#f0f8ff;border:4px solid #BF00FF;flex:1;border-radius: 20px;">
        <h2 style="text-align:center" title="Growth Stage">Grow</h2>
        <ul class="pricing-list">
          <li>Adaptive Intelligence AI</li>
          <li>Growth Frameworks</li>
          <li>AI-enhanced Workspaces</li>
          <li>AI-enhanced Tasks</li>
          <li>Progress Tracking</li>
          <li>Visual Reporting</li>
          <li>Up to 5 Users</li>
        </ul>
        <p style="font-size:2rem;text-align:center">
          $349<br>
          <span style="font-size:.8rem;">per month</span>
        </p>
        <p style="text-align:center">
          <a href="https://buy.stripe.com/6oU00i6b29eV5zU0Ge14405" target="_blank" rel="nofollow">
            <button style="padding:10px 20px;background: #BF00FF;"> Subscribe </button>
          </a>
        </p>
      </div>
    </div>

    <!-- Full Team -->
    <div class="column">
      <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;border-radius: 20px;">
        <h2 style="text-align:center" title="Scaling">Scale</h2>
        <ul class="pricing-list">
          <li>Adaptive Intelligence AI</li>
          <li>Scaling Frameworks</li>
          <li>AI-enhanced Workspaces</li>
          <li>AI-enhanced Tasks</li>
          <li>Progress Tracking</li>
          <li>Visual Reporting</li>
          <li>Up to 15 Users</li>
        </ul>
        <p style="font-size:2rem;text-align:center">
          $500<br>
          <span style="font-size:.8rem;">per month</span>
        </p>
        <p style="text-align:center">
          <a href="https://buy.stripe.com/3cI00ibvmdvb6DYcoW14406" target="_blank" rel="nofollow">
            <button style="padding:10px 20px;"> Subscribe </button>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Divider / Bridge to SaaS -->
<div class="basehero" style="padding:0 40px;text-align: center;">
  <h2>
    Need Extra Help?
  </h2>
  <p>
    <a href="https://calendly.com/foclarity" target="_blank" rel="nofollow">
      <button style="padding:10px 20px;background: #004466; color: #fff;">Schedule a Consultation</button>
    </a>
  </p>
</div>

    </div>    
  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";

export default {
  title: 'Pricing for Founder Focus and Team Alignment | Foclarity',
  description: 'See Foclarity pricing for founders and small teams who want clearer priorities, better alignment, visible progress, and AI-supported execution.',
  name: "Pricing",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    checkForMetaMask: function () {
      //Have to check the ethereum binding on the window object to see if it's installed
      const { ethereum } = window;
      var isinstalled = Boolean(ethereum && ethereum.isMetaMask);
      console.log("Metamask is connected: " + isinstalled)

      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        ethereum.request({ method: "eth_requestAccounts" });
      } catch (error) {
        console.error(error);
      }

    },
  },
  components: {},
  data () {
      return {
      }
  },
  created () {
    // this.checkForMetaMask() ;
  }
};
</script>

<style lang="scss" scoped>

.heroblue {
  background: linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #fff;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 415px) {
      font-size: 36px;
      padding: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: #fff;
    & .signupbox {
      text-align: center;
      padding: 8px;
      font-size: 24px;
      font-weight: bold;
      background: #ff7f24;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      margin: auto;
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding: 10px;
  min-width: 200px;
  & .homecard {
    text-align: center;
    padding: 20px;
    border-radius: 4px;
    background: rgba(0, 178, 238, 0.1);
    height: 100%;
    & .cardicon {
      width: 100px;
      height: 100px;
      margin: auto;
      & img {
        width: 80px;
      }
    }
    & .h3 {
      font-size: 23px;
      line-height: 32px;
      color: #CC0099;
      text-align: left;
      @media (max-width: 400px) {
        font-size: 20px;
      }
    }
  }
}

.homequote {
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-style: italic;
  color: #666;
  max-width: 600px;
  margin: 20px auto;
}
.pricing-list {
  list-style-type: none;
  padding: 0;
  & li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
}
</style>
